const scopedValue = (invoice, key) => {
  const contextId = invoice?.league_context?.[`${key}_id`];
  if (contextId === null || contextId === undefined) return null;

  const contextLabel =
    invoice.league_context[`${key}_label`] ||
    invoice.league_context[`${key}_name`];
  if (contextLabel) return contextLabel;

  const originId = invoice?.origin?.[`${key}_id`];
  const originName = invoice?.origin?.[`${key}_name`];
  if (
    originName &&
    originId !== null &&
    originId !== undefined &&
    String(originId) === String(contextId)
  ) {
    return originName;
  }

  return `#${contextId}`;
};

export const invoiceOriginMessage = (invoice, intl) => {
  const tournament = scopedValue(invoice, "tournament");
  const match = scopedValue(invoice, "match");

  if (tournament && match) {
    return intl.formatMessage(
      { id: "gestion.playerFinance.origin.both" },
      { tournament, match },
    );
  }
  if (tournament) {
    return intl.formatMessage(
      { id: "gestion.playerFinance.origin.tournament" },
      { tournament },
    );
  }
  if (match) {
    return intl.formatMessage(
      { id: "gestion.playerFinance.origin.match" },
      { match },
    );
  }

  return intl.formatMessage({ id: "gestion.playerFinance.origin.none" });
};
